import { jsx as _jsx } from "react/jsx-runtime";
import { FliptProvider, useFliptBoolean, useFliptSelector } from '@flipt-io/flipt-client-react';
import { FeatureFlagStateProvider, useFeatureFlag, useFeatureFlagsReady } from '@mono/ui-runtime/context';
import { getFliptUrl } from '../lib/connect/runtimeConfig';
const FLIPT_NAMESPACE = 'default';
const FLIPT_UPDATE_INTERVAL = 120000; // 120 seconds in ms
export { useFeatureFlag, useFeatureFlagsReady };
// Module-level constant, not built inside the component: a new object each
// render would swap the `useFlag`/`useReady` functions the context hands out,
// changing the number of hooks called by every consumer between renders.
// See the rationale in packages/ui-runtime/src/context/featureFlagContext.tsx:
// useFliptContext() is a bare useContext read of a ref Flipt mutates in
// place and never re-renders consumers. useFliptSelector subscribes via
// useSyncExternalStore, so it does.
const fliptFeatureFlagValue = {
    useFlag: (flagKey)=>useFliptBoolean(flagKey, false, 'default'),
    useReady: ()=>!useFliptSelector((_client, isLoading)=>isLoading)
};
/**
 * Wraps children with Flipt's feature flag provider.
 * Silently degrades if Flipt is unavailable.
 */ export function FeatureFlagProvider({ children }) {
    return /*#__PURE__*/ _jsx(FliptProvider, {
        namespace: FLIPT_NAMESPACE,
        options: {
            url: getFliptUrl(),
            updateInterval: FLIPT_UPDATE_INTERVAL
        },
        children: /*#__PURE__*/ _jsx(FeatureFlagStateProvider, {
            value: fliptFeatureFlagValue,
            children: children
        })
    });
}
